import { Injectable } from '@angular/core';

import { SemantriaAPIService } from '../semantria-api.service';
import { EnableClassTelemetry } from '../../services/otel.service';

export interface UserCreditStatistic {
  user_email: string;
  values: {
    api_calls_count: number;
    balance_type_decrement_amount: number;
    balance_type_set_amount: number;
    batches_queued_count: number;
    data_calls_count: number;
    docs_queued_count: number;
    docs_retrieved_count: number;
    docs_successful_count: number;
    failed_docs_count: number;
    polling_calls_count: number;
    settings_calls_count: number;
    speech_audio_length: number;
    speech_queued_count: number;
    speech_queued_docs_count: number;
    time: string;
    translation_queued_docs_count: number;
    translation_text_length: number;
  };
}
@EnableClassTelemetry()
@Injectable()
export class StatisticsService extends SemantriaAPIService {
  getCreditUsage(
    group: string,
    balanceType: string,
    startDate: string,
    endDate: string
  ): Promise<UserCreditStatistic[]> {
    const params = {
      group,
      balance_type: balanceType,
      from: startDate,
      to: endDate,
    };
    return this.get('/statistics/', params);
  }
}
